// actionTypes.js
export const SET_VALUE_ModeleLoyer = "SET_VALUE_ModeleLoyer";
export const SET_TYPE_ModeleLoyer = "SET_TYPE_ModeleLoyer";
export const SET_CURRENT_PAGE_ModeleLoyer = "SET_CURRENT_PAGE_ModeleLoyer";
export const SET_ORDER_ModeleLoyer = "SET_ORDER_ModeleLoyer";
export const SET_SORT_FIELD_ModeleLoyer = "SET_SORT_FIELD_ModeleLoyer";
export const SET_ACTIF_ModeleLoyer = "SET_ACTIF_ModeleLoyer";
export const SET_CATEGORIE_ModeleLoyer = "SET_CATEGORIE_ModeleLoyer";
